class MsgTitleWarn {
    constructor(){
        this.originalTitle = document.title;
        this.warnTitle = "【You have a new message】";
        this.timer = null;
        this.time = 1000;
        this.timeNum = 0;

    }

    showTitle(){
        let _this = this;
        document.title = this.warnTitle;

        clearInterval(_this.timer);
        this.timer = setInterval(()=>{
            this.timeNum++;
            if (_this.timeNum % 2 == 1) {
                document.title = this.warnTitle;
            } else {
                document.title = this.originalTitle;
            }
        },_this.time)
    }

    hideTitle(){
        let _this = this;
        this.timeNum = 0;
        clearTimeout(_this.timer);
        document.title =  this.originalTitle;
    }

}


export default MsgTitleWarn
